import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Link from "@material-ui/core/Link";
import PhoneForwardedIcon from "@material-ui/icons/PhoneForwarded";
import { Typography } from "@material-ui/core";
import { positioningElems } from "../../../config/theme";

export const phoneRenderer = (
    value,
    name,
    fieldUpdateHandler,
    isError,
    mutable,
) =>
    mutable || typeof fieldUpdateHandler === "function" ? (
        <TextField
            value={value || ""}
            error={!!isError}
            helperText={isError}
            onChange={(e) => fieldUpdateHandler(name, e.target.value)}
            InputProps={
                !value || value?.length === 0
                    ? {}
                    : {
                          endAdornment: (
                              <InputAdornment position="end">
                                  <Link
                                      href={"tel:" + value}
                                      target="_blank"
                                      rel="noopener"
                                  >
                                      <PhoneForwardedIcon />
                                  </Link>
                              </InputAdornment>
                          ),
                      }
            }
        />
    ) : value ? (
        <Typography
            children={[
                <span key={"phone"} style={positioningElems.inlineWithIcon}>
                    {value}
                </span>,
                <Link
                    href={"tel:" + value}
                    target="_blank"
                    rel="noopener"
                    key={"phone_key"}
                >
                    <PhoneForwardedIcon
                        style={positioningElems.distanceToIcon}
                    />
                </Link>,
            ]}
        />
    ) : (
        []
    );
